module.exports = __webpack_public_path__ + "static/media/FintwistCardArt_Generic.f86b3dec.svg";